import React from 'react'
import { motion } from 'framer-motion'
import { useNavigate } from 'react-router-dom'

// Components
import SEO from '@components/common/SEO'
import { Button } from '@components/ui/Button'

// Types
import type { FC } from 'react'

const AboutPage: FC = () => {
  const navigate = useNavigate()

  return (
    <>
      {/* SEO */}
      <SEO
        title="เกี่ยวกับเรา - ไทยเซ็กคิวริตี้ไดเรกทอรี่"
        description="แพลตฟอร์มค้นหาบริษัทรักษาความปลอดภัยในประเทศไทย"
      />

      {/* Hero Section */}
      <section className="min-h-[70vh] flex items-center justify-center bg-gradient-to-br from-primary-50 to-primary-100">
        <div className="container-wrapper">
          <motion.div
            className="text-center max-w-3xl mx-auto"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
          >
            <h1 className="text-4xl md:text-5xl font-bold text-neutral-900 mb-6">
              ไทยเซ็กคิวริตี้ไดเรกทอรี่
            </h1>
            <p className="text-xl md:text-2xl text-neutral-600 mb-8 leading-relaxed">
              แพลตฟอร์มค้นหาบริษัทรักษาความปลอดภัยในประเทศไทย
              <br />
              ข้อมูลครบถ้วน ตรวจสอบแล้ว ใช้งานฟรี
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <Button
                size="lg"
                onClick={() => navigate('/search')}
              >
                เริ่มค้นหาบริษัท
              </Button>
              <Button
                size="lg"
                variant="outline"
                onClick={() => navigate('/contact')}
              >
                ติดต่อเรา
              </Button>
            </div>
          </motion.div>
        </div>
      </section>
    </>
  )
}

export default AboutPage
